import React, { Component } from 'react';
import Select from 'react-select'
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { TableRow, TableCell, Button, Box } from '@material-ui/core';
import { AddCircleRounded } from '@material-ui/icons';


class FormCommercialRea extends Component {
    state = { }

    createShopList = () => {
        const list = []
        const { SHOPS, AVAILABLE} = this.props
        if( AVAILABLE ){
            Object.keys(SHOPS).map( ID => { 
                const shop = SHOPS[ID]                    
                let selected = !!shop.shop_disabled
                
                if(this.props.rea.shop_id === ID) {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value:ID, label:shop.name, disabled:selected} 
                )
            })
        }
        return list
    }
    createCommercialList = () => {
        const list = []
        const { AGENTS } = this.props
        if( AGENTS ){
            Object.values(AGENTS).map( agent => { 
                let selected = false
                if(this.props.rea.commercial_id === agent.id) {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value:agent.id, label:`${agent.name} - ${agent.id}`, disabled:selected} 
                )
            })
        }
        return list
    }

    render() {
        const shops = this.createShopList()
        const commercials = this.createCommercialList()
        return (
            <div className="card-text">
            {/* <h3 className="card-title">Nouveau Reappro Commercial</h3> */}
            <div className="m-5">

                <form className="form-horizontal">
                    <InputSelectMagasin
                        options={shops}
                        value={this.props.rea.shopDisplay}
                        onChange={ option => this.props.handleSelect(option,"shop_id")}
                        // isOptionDisabled={ option => option.disabled === true}
                        error={this.props.errors.shop_id}
                        label="Magasin"
                    /> 
                    
                    {/* <div className={"form-group "+ (this.props.errors.shop_id ? "has-error" : "") }>
                        <label htmlFor="shop_id" className="col-sm-3 control-label">Shop</label>
                        <div className="col-sm-9">
                            <Select
                                options={shops}
                                value={this.props.rea.shopDisplay || {value:"", label:""}}
                                onChange={ option => this.props.handleSelect(option,"shop_id")}
                                isOptionDisabled={ option => option.disabled === true}
                            /> 
                            <small className="help-block">{this.props.errors.shop_id}</small>
                        </div>
                    </div> */}
                    
                    <InputSelectMagasin
                        options={commercials}
                        value={this.props.rea.commercialDisplay}
                        onChange={ option => this.props.handleSelect(option,"commercial_id")}
                        // isOptionDisabled={ option => option.disabled === true}
                        error={this.props.errors.commercial_id}
                        label="Commercial"
                    /> 
                    {/* <div className={"form-group "+ (this.props.errors.commercial_id ? "has-error" : "") }>
                        <label htmlFor="commercial_id" className="col-sm-3 control-label">Commercial</label>
                        <div className="col-sm-9">
                            <Select
                                options={commercials}
                                value={this.props.rea.commercialDisplay || {value:"", label:""}}
                                onChange={ option => this.props.handleSelect(option,"commercial_id")}
                                isOptionDisabled={ option => option.disabled === true}
                            /> 
                            <small className="help-block"></small>
                        </div>
                    </div> */}
                    <InputText type="number" step="0.01" id="transport" onChange={this.props.handleChange} value={this.props.rea.transport} name="transport" label="Coût Transport" error={this.props.errors.transport}
                    />
                    {/* <div className={"form-group "+ (this.props.errors.transport ? "has-error" : "") }>
                        <label htmlFor="transport" className="col-sm-3 control-label">Transport</label>
                        <div className="col-sm-9">
                            <div className={"fg-line "}>
                                <small className="help-block"></small>
                            </div>
                        </div>
                    </div> */}
                    

                    <div className="col-xs-12">
                    {/* <FormLayout title={"Produits"} rea>
                        {this.props.createAddForm()}
                        <TableRow className="plus-btn" onClick={this.props.handleAddProd}>
                            <TableCell colSpan={4}>
                                <a> 
                                    <AddCircleRounded />
                                    <span>Ajouter un produit</span> 
                                </a>
                            </TableCell>
                        </TableRow>
                    </FormLayout> */}
                    <FormLayout 
                        {...this.props} 
                        title={"Produits"}
                        rea
                        createAddForm={this.props.createAddForm}
                        onClick={this.props.handleAddProd}
                        onClickForCSVUpload={this.props.handleAddProdByCSV}
                        colSpan={2}
                    /> 
                    
                    </div>
                    
                </form>
                    
                <Box p={2}>
                    <div className="pull-right">
                        <Button color="secondary" variant="contained" onClick={this.props.validate}>Valider</Button>
                        <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                    </div>
                </Box>
            </div>
        </div>
        );
    }
}

export default FormCommercialRea;